var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage"
  }, [_c('div', {
    attrs: {
      "id": "cards"
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('flippable-card', {
      key: step.stepIndex,
      staticClass: "card",
      attrs: {
        "is-flipped": step.stepIndex < _vm.progress.stepIndex
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back"
      },
      slot: "card-back"
    }, [_c('img', {
      attrs: {
        "src": _vm.backOfCardPath
      }
    })]), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front"
      },
      slot: "card-front"
    }, [_c('img', {
      attrs: {
        "src": step.img
      }
    })])]);
  }), 1), _c('div', {
    attrs: {
      "id": "answers"
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('div', {
      key: ("answer-" + (step.stepIndex)),
      staticClass: "answer"
    }, [_c('span', [_vm._v(_vm._s(step.toShow))]), _c('blinking-cursor-text', {
      attrs: {
        "text": step.toType,
        "text-step": step.stepIndex
      }
    })], 1);
  }), 0), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }